import { Injectable } from "@angular/core";
import { RegionItem } from "projects/phdsoft/common/src/lib/models";
import { AbstractCacheService } from "src/app/shared/services/abstract-cache.service";

@Injectable({
    providedIn: 'root'
  })
  export class RegionsCacheService extends AbstractCacheService<RegionItem[]> {

  }
